export default __webpack_public_path__ + "static/media/requestRailQuotation.5a4f3380.svg";